<template>
  <div class="card">
      <div class="card card-custom" >
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">{{ $t('contactStatus.list') }}</h3>
          </div>
          <div class="card-toolbar">
            <Button btn-class="btn-sm" type="new" btn-text="contactStatus.create" @click="openContactStatusModal"/>
          </div>
        </div>

        <div class="card-body" >
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_contactStatus" style="margin-top: 13px !important; cursor:pointer">
            <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-200px">{{ $t('contactStatus.title')}}</th>
              <th class="w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <CustomerStatusFormModal id="create-contactStatus-modal" @callback="fetchDatas"/>
    <CustomerStatusFormModal id="edit-contactStatus-modal" :status="formUpdateData" @callback="fetchDatas" :isEdit="true"/>
</template>

<script setup>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import i18n from '@/plugins/i18n';
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import {$formatLocalAmount} from "@/mixins/Helpers"
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import Button from "@/components/Button.vue"
import {useSwal} from "@/composables/useSwal";
import {Theme} from "@/composables/theming";
import abilities from "@/composables/abilities";
import TaskStatusModal from "../../../components/Modals/TaskStatusModal"
import CustomerStatusFormModal from "@/Modules/Projects/components/Modals/CustomerStatus/CustomerStatusFormModal.vue";

const {showSwal} = useSwal()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const currency = computed(() => 'XOF')
const { can } = useHasAbility()

const table = ref()

const formUpdateData = ref({
  id:'',
  name: '',
})

watch(() => locale.value, () => {
  nextTick(() => fetchDatas() )
})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')
  table.value = $("#kt_datatable_contactStatus").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit || 5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'asc']],
    ajax: {
      url: BASE_URL + "/get/contactStatus/datatable",
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "name" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -2,
        orderable:false,
        searchable:false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
            return '<span >' + t + "</span>";
        },
      },
      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: function(t, a, e, l) {
          let render=""
          if(can(abilities.UPDATE_COLUMN)){
            render+='<a data-id="'+ e.id +'" data-name="'+ e.name +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'" data-name="'+ e.name +'" class="fas fa-edit fs-2"  style="color: '+Theme.gray +'" ></i></a>'
          }
          if(can(abilities.DELETE_COLUMN)){
            render += '<a data-id="'+ e.id +'" href="javascript:;" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'" ></i></a>'
          }
          return render
        },
      },
    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_contactStatus .edit_btn", (e) => {
    formUpdateData.value.id = e.target.getAttribute('data-id')
    formUpdateData.value.name = e.target.getAttribute('data-name')
    $('#edit-contactStatus-modal').modal('toggle')
  });

  $(document).on("click", "#kt_datatable_contactStatus .delete_btn", (e) => {
    const target = e.target.closest('#kt_datatable_contactStatus .delete_btn');
    deleteConatctStatus(target.getAttribute('data-id'))
  });
}

function openContactStatusModal() {
  $('#create-contactStatus-modal').modal('toggle')
}

async function deleteConatctStatus(id) {
    showSwal(
        i18n.global.t('swal.contactStatus'),
        i18n.global.t('swal.contactStatus_text')
    ).then( async (result) => {
        if (result.value) {
            try {
                store.dispatch('customerStatus/deleteCustomerStatus', id)
                    .then(() => {
                      table.value.ajax.reload()
                      window.toastr['success'](i18n.global.t("notification.contact_status_deleted_successfully"))
                    })

            }catch (e) {
            }
        }
  })
}

onMounted(() => {
  fetchDatas()
})
</script>
